import { useState } from 'react';
import Button from '@/ui/button/Button';
import s from './bottom-buttons.module.css';

const BottomButtons = ({ onSave, onDelete, text, style = {}, saveDisabled, loading }) => {
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

	return (
		<div className={s.container} style={style}>
			{!confirmDialogOpen ? (
				<div className={s.buttons}>
					<Button
						text={text || 'Αποθήκευση'}
						onClick={onSave}
						disabled={saveDisabled}
						loading={loading}
						extraStyle={s.saveButton}
						extraTextStyle={s.saveButtonText}
						// style={{ marginTop: 0 }}
					/>
					{onDelete && (
						<Button
							text='Διαγραφή'
							// onClick={() => setConfirmDialogOpen(true)}
							onClick={() => setConfirmDialogOpen(true)}
							extraStyle={s.delButton}
							extraTextStyle={s.delButtonText}
						/>
					)}
				</div>
			) : (
				<>
					<div style={{ alignSelf: 'center' }}>Είσαι σίγουρος?</div>
					<div className={s.buttons}>
						<Button
							text='Ναι'
							onClick={onDelete}
							// disabled={saveDisabled}
							extraStyle={s.saveButton}
							extraTextStyle={s.saveButtonText}
						/>
						<Button
							text='Όχι'
							onClick={() => setConfirmDialogOpen(false)}
							// disabled={saveDisabled}
							extraStyle={s.saveButton}
							extraTextStyle={s.saveButtonText}
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default BottomButtons;
